/*
 * generic actions
 */
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILED = 'FETCH_FAILED';

export const GET_TM_METADATA_REQUEST = 'GET_TM_METADATA_REQUEST';
export const GET_TM_METADATA_SUCCESS = 'GET_TM_METADATA_SUCCESS';

export const fetchRequest = function (payload) {
  return { type: FETCH_REQUEST, payload };
};

export const fetchSuccess = function (payload) {
  return { type: FETCH_SUCCESS, payload };
};

export const fetchFailed = function (payload) {
  return { type: FETCH_FAILED, payload };
};

export const getTMMetadataRequest = function (payload) {
  return { type: GET_TM_METADATA_REQUEST, payload };
};

export const getTMMetadataSuccess = function (payload) {
  return { type: GET_TM_METADATA_SUCCESS, payload };
};
